import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CognitoService } from '../../services/cognito.service';
import { InitService } from '../../services/init.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loading = false;
  showLoginButton = true;
  statusTitle = 'Iniciar sesión';
  statusMessage = 'Usa Cognito para acceder a Operaciones.';
  statusDetail = '';
  actionLabel = 'Ingresar con Cognito';
  isAccessDenied = false;
  errorMessage = '';
  imgLogo = 'assets/brand/explo-horizontal-blanco.svg';
  imgLogoPrincipal = 'assets/brand/explo-original-naranja-crop.svg';

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly cognitoService: CognitoService,
    private readonly serviceInit: InitService
  ) {
    this.serviceInit.setEstadoLayout(false);
  }

  async ngOnInit(): Promise<void> {
    const error = this.route.snapshot.queryParamMap.get('error');
    const hasAccessDenied = error === 'access_denied' || sessionStorage.getItem('auth_access_denied') === '1';
    if (hasAccessDenied) {
      sessionStorage.setItem('auth_access_denied', '1');
      sessionStorage.removeItem('auth_signed_out');
      this.showAccessDenied();
      return;
    }

    if (error) {
      this.showManualLogin(
        'No se pudo validar tu sesión',
        'Inicia sesión nuevamente desde Cognito.',
        'Ingresar con Cognito',
        'No pudimos confirmar tu sesión actual.'
      );
      return;
    }

    const wasSignedOut = sessionStorage.getItem('auth_signed_out') === '1';
    if (wasSignedOut) {
      this.clearAuthFlowFlags();
      this.showManualLogin(
        'Sesión cerrada',
        'Cerraste sesión correctamente.',
        'Ingresar con Cognito',
        'Usa Cognito para iniciar nuevamente.'
      );
      return;
    }

    try {
      const isAuthenticated = await this.cognitoService.isAuthenticated();
      if (isAuthenticated) {
        const isAuthorized = await this.cognitoService.isAuthorized();
        if (!isAuthorized) {
          sessionStorage.setItem('auth_access_denied', '1');
          await this.cognitoService.signOut();
          return;
        }

        await this.cognitoService.hydrateUserContext();
        this.serviceInit.setEstadoLayout(true);
        await this.router.navigateByUrl('/home');
        return;
      }

      await this.loginWithCognito();
    } catch (error) {
      console.error('Error validando sesión:', error);
      this.showManualLogin(
        'Iniciar sesión',
        'Ingresa nuevamente con Cognito para continuar.',
        'Ingresar con Cognito',
        'Si el problema continúa, revisa tu sesión de Cognito.'
      );
    }
  }

  async loginWithCognito(): Promise<void> {
    this.clearAuthFlowFlags();
    await this.cognitoService.signInWithHostedUi();
  }

  private showAccessDenied(): void {
    sessionStorage.setItem('auth_access_denied', '1');
    this.showManualLogin(
      'Acceso denegado',
      'No tienes permisos para acceder a Operaciones.',
      'Volver a intentarlo',
      'Permisos requeridos: ADMIN_OPERACIONES o ACCESS_DEV.',
      true
    );
  }

  private showManualLogin(
    title: string,
    message: string,
    actionLabel = 'Ingresar con Cognito',
    detail = '',
    isAccessDenied = false
  ): void {
    this.loading = false;
    this.showLoginButton = true;
    this.statusTitle = title;
    this.statusMessage = message;
    this.statusDetail = detail;
    this.actionLabel = actionLabel;
    this.isAccessDenied = isAccessDenied;
    this.errorMessage = message;
  }

  private clearAuthFlowFlags(): void {
    sessionStorage.removeItem('auth_signed_out');
    sessionStorage.removeItem('auth_access_denied');
  }
}
